
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ThemeProviderWrapper from './theme/ThemeProvider';
import AppRouter from './router';
import CustomSnackbarProvider from './components/SnackbarProvider'
import './globalStyles.css'
import 'swiper/css';
import 'swiper/css/navigation';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import 'swiper/css/pagination';

function App() {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProviderWrapper>
          <CustomSnackbarProvider>
            <CssBaseline />
            <AppRouter />
          </CustomSnackbarProvider >
      </ThemeProviderWrapper>
    </LocalizationProvider >
  );
}

export default App;
